<p>
  {{'page-not-found' | translate}}
</p>
